import { render, staticRenderFns } from "./SocialMediaConnect.vue?vue&type=template&id=53ccde5a&scoped=true&"
import script from "./SocialMediaConnect.vue?vue&type=script&lang=js&"
export * from "./SocialMediaConnect.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaConnect.vue?vue&type=style&index=0&id=53ccde5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ccde5a",
  null
  
)

export default component.exports